const queryKeys = {
  accountDetails: "account-details",
  closeMarginCall: "close-margin-call",
  correspondentSummary: "correspondent-summary",
  getBalances: "get-balances",
  getCashBalances: "get-cash-balances",
  getMargins: "get-margins",
  getMarginCalls: "get-margin-calls",
  getMarginCall: "get-margin-call",
  getCallsAndAlertsDetails: "get-call-and-alerts-details",
  getCallsAndAlertsOpenDetails: "get-call-and-alerts-open-details",
  getCorrespondentsList: "get-correspondents-list",
  getCallsAndAlertsNotes: "get-calls-and-alerts-notes",
  getCallOrAlert: "get-call-or-alert",
  getEventNames: "get-event-names",
  getMargin: "get-margin",
  getCustomerSummary: "get-customer-summary",
  getRequirements: "get-requirements",
  getLastProcessDate: "get-last-process-date",
  getBallanceRollup: "get-balance-rollup",
};

export default queryKeys;
